import { FilterSelectItem } from '../../components/checkbox-facette/checkbox-liste/filterSelectItem';

export function sortFilterItems(filterList: FilterSelectItem[]): FilterSelectItem[] {
  return [...(filterList ?? [])].sort(
    (a, b) =>
      (b.active ? 1 : -1) + (!!b.treffer ? 1 : -1) - ((a.active ? 1 : -1) + (!!a.treffer ? 1 : -1))
  );
}
